import { render, staticRenderFns } from "./member-view.vue?vue&type=template&id=4643ba44&scoped=true";
import script from "./member-view.vue?vue&type=script&lang=js";
export * from "./member-view.vue?vue&type=script&lang=js";
import style0 from "./member-view.vue?vue&type=style&index=0&id=4643ba44&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "4643ba44", null);
export default component.exports;